<template>
  <div class="modal fade" id="app_info_modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="color: #9b9b9b;" id="exampleModalLongTitle">订单详情</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">订单号</label>
              <div class="col-sm-10">
                <label class="col-form-label">{{payOrder.orderId}}</label>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">订单描述</label>
              <div class="col-sm-10">
                <label class="col-form-label">{{payOrder.goodsName}}</label>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">价格</label>
              <div class="col-sm-10">
                <label class="col-form-label">{{payOrder.goodsPrice/100}}</label>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">创建时间</label>
              <div class="col-sm-10">
                <label class="col-form-label">{{payOrder.createTime | formatDateTime}}</label>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">支付方式</label>
              <div class="col-sm-10">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="payWay" value="1" checked>
                  <label class="form-check-label" for="inlineRadio1">微信</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="payWay" value="2">
                  <label class="form-check-label" for="inlineRadio2">支付宝</label>
                </div>
              </div>
            </div>
          </form>
          <div id="pay_qrcode">
            <!-- <img style="height: 3em;" src="/static/img/WePayLogo.png"> -->
            <h4 v-if="money" style="color:red">请务必输入：{{money}}</h4>
            <p></p> 
            <div>
              <div id="qrcode" style="display: none"></div>
              <span class="qrcode" title>
                <img style="height:10em" alt="Scan me!" src>
              </span>
            </div>
            <br>
            <p style="color:#F76C24">支付成功后，请到 >> 分发管理 页面核查 如有疑问联系客服：{{_Global.QQ}}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button
            @click="pay"
            type="button"
            class="btn btn-primary"
            :disabled="pay_button_disabled"
          >立即支付</button>
        </div>
      </div>
    </div>
    <WebSocket v-on:webSocketHandle="webSocketHandle"/>
  </div>
</template>
<script>
import WebSocket from "./WebSocket";
var self;
export default {
  props: ["payOrder"],
  components: {
    WebSocket
  },
  data() {
    return {
      wx_pay_qrcode: null,
      pay_button_disabled: false,
      money:null
    };
  },
  mounted() {
    self = this;
    $("#pay_qrcode").hide();
    this.$nextTick(() => {
      $("#app_info_modal").modal("show");
      $("#app_info_modal").on("hidden.bs.modal", function(e) {
        console.log("模态框消失");
        self.$emit("closeVipOrderDetail", false);
      });
    });
  },
  methods: {
    pay: function() {
      var payWay = $("input:radio[name='payWay']:checked").val();
      var orderNum = this.payOrder.orderId;
      window.layer.msg("正在生成第三方支付订单，请耐心等待", {
        time: 999999
      });
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/vip/pay", {
          payWay: payWay,
          orderNum: orderNum,
          authToken: this.getToken()
        })
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            window.layer.closeAll();
            console.log("tag", data);
            $("#pay_qrcode").show();
            self.pay_button_disabled = true;
            var qrcode = jQuery("#qrcode").qrcode(data.code_url);
            var canvas = qrcode.find("canvas").get(0);
            $(".qrcode img").attr("src", canvas.toDataURL("image/jpg"));
            if(payWay==2){
              document.write(data);
            }
          });
        });
    },
    webSocketHandle: function(data) {
      console.log("tag", data);
      var obj = JSON.parse(data);
      if (obj.orderId !== this.payOrder.orderId) {
        return;
      }
      window.layer.msg("支付成功,页面正在跳转...");
      setTimeout(function() {
        $("#app_info_modal").modal("hide");
        self.$router.push("/apps");
      }, 2000);
    }
  }
};
</script>
<style scoped>
.content {
  text-align: left;
}
.modal-body {
  text-align: center;
}
.form-check {
  margin-right: 1em;
  margin-left: 0;
}
.modal-footer button {
  text-align: center;
  width: 100%;
}

.form-group div {
  text-align: left
}
</style>




// WEBPACK FOOTER //
// src/components/VipOrderDetail.vue